import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment-timezone';
import Cell from './Cell';
import { getRoomShortTitle } from '../../../../common';

export const TableRows = (props) => {
    const rowData = props.data ? props.data[props.title] : undefined;
    const startDate = moment(props.startDate);
    const title = getRoomShortTitle(props.title);
    
    return (
        <tr className={`${props.title.replace(/\W+/ig, '')} set-height row-${props.rowNumber}`} id={`${props.title.replace(/\W+/ig, '')}${props.rowNumber}`}>
            {
                props.rowSpan >= 1 ?
                    (
                        <td rowSpan={props.rowSpan} style={{ width: 40, fontSize: 18, fontFamily: 'Nunito' }}>{title} <br />
                        </td>
                    )
                    : ''
            }
            <td style={{ width: 40, height: 15 }}>{props.subtitle}</td>
            {_.times(Math.round(props.day / 3.5), (i) => {
                let cellData = {};
                let colspan = 0;
                const currentDate = startDate.clone().format('YYYY-MM-DD');
                if (rowData) {
                    cellData = rowData[currentDate] ? rowData[currentDate][props.rowNumber]
                        : undefined;
                    if (cellData !== undefined) {
                        const startDateRoom = new Date(cellData.Start_Date__c);
                        const endDateRoom = new Date(cellData.End_Date__c);

                        const timeDiff = Math.abs(startDateRoom.getTime() - endDateRoom.getTime());

                        colspan = Math.ceil(timeDiff / (1000 * 3600 * 24));
                    } else {
                        colspan = startDate.format('dd') === 'Mo' ? 4 : 3;
                    }
                }
                colspan = startDate.format('dd') === 'Mo' ? 4 : 3;

                const elements = (<Cell
                    key={i + props.title}
                    rowNumber={props.rowNumber}
                    iteration={i}
                    cellColor={props.cellColor}
                    isEmpty={cellData === {}}
                    additionalClass={props.additionalClass}
                    data={cellData}
                    dataId={i}
                    colSpan={colspan}
                    currentDate={currentDate}
                    showDetail={props.changeVisitModal}
                    selectedCellId={props.selectedCellId}
                    setSelectedCellId={props.setSelectedCellId}
                    previousCellStatus={props.previousCellStatus}
                    setPreviousCellStatus={props.setPreviousCellStatus}
                />);
                startDate.add(colspan, 'days');
                return elements;
            })}
        </tr>
    );
};

TableRows.propTypes = {
    changeVisitModal: PropTypes.func.isRequired,
    day: PropTypes.number.isRequired,
    data: PropTypes.object,
    rowSpan: PropTypes.number.isRequired,
    subtitle: PropTypes.string,
    startDate: PropTypes.string.isRequired,
    // image: PropTypes.string,
    title: PropTypes.string.isRequired,
    additionalClass: PropTypes.string.isRequired,
    rowNumber: PropTypes.number.isRequired,
    cellColor: PropTypes.string,
};

TableRows.defaultProps = {
    data: {},
    subtitle: '',
    cellColor: '#fff',
};

export default TableRows;
